import React from 'react';
import { LeftOutlined } from '@ant-design/icons';
import { Link } from "react-router-dom";


function StartingBanner(props) {

    return (
        <div {...props}>
            <div className="home-page starting-banner">
                <h4>مدتاک، همراه شما برای برای ساخت آینده ای بهتر</h4>
                <p>چطور شروع کنم ؟</p>
                <div style={{ marginTop: 20, textAlign: 'center' }}>
                    <div className="actions-box" style={{ marginTop: 20 }}>
                        <Link href="/online-class/plans" to="/online-class/plans" className="ant-btn bold-btn">
                        ساخت کلاس رایگان
                        </Link>
                        <Link href="/online-class/plans" to="/online-class/plans" className="my-link">
                        مشاهده تعرفه ها<LeftOutlined />
                        </Link>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default StartingBanner;